module.exports = "<app-side-nav></app-side-nav>\n"